import React, {useState} from "react";
import Modal from "../../../components/atoms/Modal";
import BtnModal from "../../../components/atoms/BtnModal";
import InputCalendar from "./InputCalendar";
import {TransactionRepository} from "../../../repository/AdminDashboard/transaction-Repository";
import {API_BASE_URL} from "../../../clases/request";
import toast, {ToastBar} from "react-hot-toast";

const ExportModal = ({showModal, closeModal}) => {
    const [limitStart, setLimitStart] = useState()
    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()


    const changeStartDate = (event) => {
        setLimitStart(event.valueOf())
        const date = new Date(event.valueOf());
        setStartDate(date)
    }

    const changeEndDate = (event) => {
        const date = new Date(event.valueOf());
        setEndDate(date)
    }

    async function onBtnClick() {
        const token = localStorage.getItem("token");
        const response = await TransactionRepository.fileexport(
            convertTimestampToString(startDate),
            convertTimestampToString(endDate)
        );
        if (response.code === 1) {
            const a = document.createElement("a");
            a.href = `${API_BASE_URL}/transaction/export/${convertTimestampToString(startDate)}/${convertTimestampToString(endDate)}/${token}`;
            a.setAttribute("target", "_blank");
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            closeModal();

        }else{
            console.log("ELSE ",response)
            toast.error(response.message, {
                className: "text-12 text-dark-blue-200",
            });
        }
    }

    function convertTimestampToString(timeStamp) {
        const years = timeStamp.getFullYear();
        const months = timeStamp.getMonth() + 1;
        const days = timeStamp.getDate();
        return `${years}_${("0" + months).slice(-2)}_${("0" + days).slice(-2)}`;
    }


    if (!showModal) {
        return null;
    }
    return (
        <Modal title={"دریافت خروجی اکسل"} closeModal={closeModal}>
            <div className="flex flex-row w-full gap-5">

                <InputCalendar
                    position={"right-top"}
                    onChange={changeStartDate}/>

                <InputCalendar
                    position={"left-top"}

                    onChange={changeEndDate} mindate={limitStart}/>

            </div>

            <div className="flex items-center justify-end pt-5.5">

                {/* <a href={fileUrl} download={valT} className="w-full"> */}

                <BtnModal text={"دریافت فایل"} accept={onBtnClick}/>

            </div>
        </Modal>
    );
};

export default ExportModal;
